<template>
    <div v-if="visible" style="width: 100%; padding: 0px 3.33vmin">
        <div class="row">
            <div class="col">
                <AnswerMarking :marking-class="markingClass" />
                <q-chip style="background-color: #e8dfff; color: #424242; font-weight: 500"><span style="font-weight: 500">확인문제 풀이</span> </q-chip>
            </div>
            <div class="col" style="text-align: end">
                <!-- <q-btn flat>
                    <q-icon name="sym_o_help" style="font-size: 2.333vmin; color:#616161" />
                    <q-tooltip class="pen-tooltip tooltip__txt" anchor="center right" self="center left"
                        v-model="penTooltip" transition-show="jump-right" transition-hide="jump-left">
확인 문제는 문제를 잘 이해했는지 점검하는 문제입니다. 이전 문제를 떠올리며 풀어 보세요.                     </q-tooltip>
                </q-btn> -->
                <Help2 class="question-mark" width="320px">
                    <div class="pd_left_10 mark__list">확인문제는 문제를 잘 이해했는지 점검하는 문제입니다. 이전 문제를 떠올리며 풀어 보세요.</div>
                </Help2>
            </div>
        </div>
        <div>
            <div>
                <!-- {{ question }} -->
                <!-- <hr /> -->
                <div v-html="question"></div>
                <!-- <div>
                    <v-runtime-template :template="question"></v-runtime-template>
                </div> -->
            </div>
            <br />
            <div style="width: 100%">
                <q-radio
                    :disable="disable || wrongList.includes(item.numChar)"
                    v-if="choiceArrange"
                    v-for="(item, index) in choiceArrange.data"
                    class="col"
                    style="padding: 10px; border-radius: 10px; border: 1px solid #e0e0e0; justify-content: center; margin: 0px 5px 5px"
                    v-model="choice"
                    :val="item.numChar"
                    :class="wrongList.includes(item.numChar) ? 'item-wrong' : item.numChar === choice ? 'item-select' : 'item-nomal'"
                    @update:model-value="onChangeAnswer"
                >
                    <div v-html="item.text"></div>
                </q-radio>
            </div>
            <br />
            <br />
            <br />
        </div>
    </div>
    <!-- <FloatingNotify :text="msg" text-only="true" @resetMsg="() => { msg = '' }" /> -->
    <!-- <q-option-group v-model="choice" :options="options" color="red" /> -->
</template>

<script setup>
import { onMounted, onUnmounted, ref, defineEmits, defineProps, watch, toRaw } from 'vue';
import { getQuestion_old, getChoice, getAnswerDetail } from '@/helpers/qbankParser/qbankDataParse';
import { useQuasar } from 'quasar';
import VRuntimeTemplate from 'vue3-runtime-template';
import AnswerMarking from './answerMarking.vue';
import { getKrtProblem } from '@/api/modules/qbank';
import * as zzQbank from '@/api/modules/qbank';
import Help from '../quasar/help.vue';
import Help2 from '../quasar/help2.vue';
import { soundEffect } from '@/helpers/soundEffect';
import FloatingNotify from '../quasar/floatingNotify.vue';
import { StudyStore } from '@/store/modules/study';
import tttest3 from '@/views/paper/tttest3.json';
import tttest2 from '@/views/paper/tttest2.json';
import { getAddCharQbankData } from '@/views/eval_qbank/exam_common.js';
import { useLocalLog } from '@/helpers/utils';

const question = ref('');
const choiceArrange = ref([]);
const choice = ref('');
const markingClass = ref('');
const correctAnswer = ref([]);
const disable = ref(false);
const visible = ref(false);
const msg = ref('');
const wrongList = ref([]);
const studyStore = StudyStore();
let noti = null;

const emit = defineEmits(['setRelationAnswer', 'onClose', 'setMessage']);
const $q = useQuasar();

const props = defineProps({
    pContent: {
        default: {},
    },
    isViewMode: {
        default: false,
    },
    isINSPECT: { default: false },
});

const onChangeAnswer = (v, evt) => {
    log && console.log('== problemRelation : onChangeAnswer : v : ', v);
    // emit('setAnswer', v);
    log && console.log('== problemRelation : onChangeAnswer : correctAnswer : ', correctAnswer.value);
    if (correctAnswer.value.includes(choice.value)) {
        log && console.log('== problemRelation : onChangeAnswer : correctAnswer.includes(choice.value) : ', choice.value);
        soundEffect('correct');
        markingClass.value = 'marking-right';
        // msg.value = '정답이에요!';
        emit('setMessage', '정답이에요!');
        // noti !== null && noti();
        // noti = $q.notify({
        //     group: true,
        //     //    timeout: 5,
        //     // message: '정답이에요! 확인해야 할 개념 영상이 있어요',
        //     // TODO: 영상있을시 추가 메세지 작업
        //     message: '정답이에요!',
        //     // color: 'secondary',
        //     classes: 'force-inline',
        //     position: 'right',
        //     multiLine: true,
        //     timeout: 1000
        //     //    actions: [{ label: '틀렸어요', icon: 'arrow_back_ios', color: 'yellow', handler: () => { nextStep(false); } }],
        // })
        disable.value = true;
        emit('setRelationAnswer', choice.value);
    } else {
        log && console.log('== problemRelation : onChangeAnswer : correctAnswer.includes(choice.value) else : ', choice.value);
        wrongList.value.push(choice.value);
        log && console.log('== problemRelation : onChangeAnswer : wrongList : ', wrongList.value);
        soundEffect('wrong');
        markingClass.value = 'marking-halfWrong';
        emit('setMessage', '다시 한 번 풀어 보세요.');
        // msg.value = '다시 한 번 풀어 보세요.';
        // noti !== null && noti();
        // noti = $q.notify({
        //     group: true,
        //     //    timeout: 5,
        //     message: '틀렸어요! 다시 한번 확인해볼까요?',
        //     // color: 'secondary',
        //     classes: 'force-inline',
        //     position: 'right',
        //     multiLine: true,
        //     timeout: 1000
        //     //    actions: [{ label: '틀렸어요', icon: 'arrow_back_ios', color: 'yellow', handler: () => { nextStep(false); } }],
        // })
    }
};

const init = async (newValue) => {
    const vContent = toRaw(newValue);
    log && console.log('== problemRelation : init : vContent : ', vContent);
    // console.log('- - -vContent-version', vContent.data.content.version);

    const relationId = vContent.data.content.property.problem?.relations?.length > 0 ? vContent.data.content.property.problem.relations[0].relationId : null;

    log && console.log('== problemRelation : init : relationId : ', relationId);
    if (relationId) {
        if (props.isINSPECT) {
            log && console.log('== problemRelation : init : isINSPECT true: ', props.isINSPECT);
            // console.log('-%% isINSPECT %%% relationId ', relationId);

            const res1 = await zzQbank.getKrtProblem_Inspect({
                version: vContent.data.content.version,
                problemId: relationId,
                // version: '1.00.01', problemId: 382222
            });
            log && console.log('== problemRelation : init : getKrtProblem : res1 : ', res1);
            if (res1 && res1.status === 200) {
                // console.log('-%% isINSPECT %%%-getKrtProblem--res1:', res1);
                // console.log('-%% isINSPECT %%%-getKrtProblem--res1 data:', res1.data);
                const r = res1.data.data;
                // console.log('-%% isINSPECT %%%-getKrtProblem--r:', r);
                // r = getAddCharQbankData(r);
                // const res = r;
                // console.log('-problemRelation-getKrtProblem-res-', res);
                log && console.log('== problemRelation : init : getKrtProblem : r : ', r);
                question.value = getQuestion_old(r);
                // question.value = getQuestion_old_for_problemRelation(res);
                // console.log('--getKrtProblem-r-', r);
                // question.value = getQuestion_old_for_problemRelation(tttest3);
                // console.log('--getKrtProblem-tttest3-', tttest3);
                // question.value = getQuestion_old_for_problemRelation(tttest2);
                // console.log('--getKrtProblem-tttest2-', tttest2);

                choiceArrange.value = getChoice(r);
                log && console.log('== problemRelation : init : getChoice : ', choiceArrange.value);
                correctAnswer.value = getAnswerDetail(r);
                visible.value = true;
                // console.log(newValue);
                log && console.log('== problemRelation : init : newValue : ', newValue);
                if (newValue.completeYn) {
                    log && console.log('== problemRelation : init : completeYn true : ', newValue.completeYn);
                    markingClass.value = 'marking-right';
                    disable.value = true;
                    choice.value = getAnswerDetail(r)[0];
                    log && console.log('== problemRelation : init : getAnswerDetail : choice : ', choice.value);
                    // choice.value = getAnswerDetail_problemRelation(tttest3)[0];
                    emit('setRelationAnswer', choice.value, true);
                }
            }
        } else log && console.log('== problemRelation : init : isINSPECT false : ', props.isINSPECT);
        getKrtProblem(
            {
                version: vContent.data.content.version,
                problemId: relationId,
                // version: '1.00.01', problemId: 382222
            },
            (r) => {
                log && console.log('== problemRelation : init : getKrtProblem : ', r);
                // console.log('-%%%%%-getKrtProblem--r:', r);
                const res = getAddCharQbankData(r);
                log && console.log('== problemRelation : init : getKrtProblem : res : ', res);
                // const res = r;
                // console.log('-problemRelation-getKrtProblem-res-', res);

                question.value = getQuestion_old(res);
                log && console.log('== problemRelation : init : getQuestion_old : ', question.value);
                // question.value = getQuestion_old_for_problemRelation(res);
                // console.log('--getKrtProblem-r-', r);
                // question.value = getQuestion_old_for_problemRelation(tttest3);
                // console.log('--getKrtProblem-tttest3-', tttest3);
                // question.value = getQuestion_old_for_problemRelation(tttest2);
                // console.log('--getKrtProblem-tttest2-', tttest2);

                choiceArrange.value = getChoice(res);
                log && console.log('== problemRelation : init : getChoice : ', choiceArrange.value);
                correctAnswer.value = getAnswerDetail(res);
                log && console.log('== problemRelation : init : getAnswerDetail : ', correctAnswer.value);
                visible.value = true;
                // console.log(newValue);
                log && console.log('== problemRelation : init : newValue : ', newValue);
                log && console.log('== problemRelation : init : completeYn : ', newValue.completeYn);
                log && console.log('== problemRelation : init : relationResult : ', newValue.relationResult);
                if (newValue.completeYn && newValue.relationResult) {
                    log && console.log('== problemRelation : init : completeYn true : ', newValue.completeYn);
                    markingClass.value = 'marking-right';
                    disable.value = true;
                    choice.value = getAnswerDetail(res)[0];
                    log && console.log('== problemRelation : init : getAnswerDetail : choice : ', choice.value);
                    // choice.value = getAnswerDetail_problemRelation(tttest3)[0];
                    emit('setRelationAnswer', choice.value, true);
                }
            },
        );
    }
};

let log = useLocalLog();

watch(
    () => props.pContent,
    (newValue) => {
        visible.value = false;
        init(newValue);
    },
);

onMounted(() => {
    log && console.log('== problemRelation : props : ', props);
    if (props.isViewMode) {
        disable.value = true;
    }
    init(props.pContent);
});

onUnmounted(() => {
    visible.value = false;
    //
});
</script>

<style lang="scss" scoped>
::v-deep p {
    margin: 0px;
}

::v-deep .q-radio__inner {
    display: none;
}

::v-deep .item {
    &-nomal {
        // background-color: #efefef;
        border-radius: 10px;

        .item-num {
            border-radius: 20px;
            border: 1px solid lightgray;
            padding: 0px 8px 2px;
        }
    }

    &-select {
        background-color: #efefef;
        border-radius: 10px;

        .item-num {
            border-radius: 20px;
            background-color: lightgray;
            padding: 0px 8px 2px;
        }
    }

    &-correct {
        background-color: #d7eaff;
        border-radius: 10px;

        .item-num {
            background-color: #6aaefc;
            border-radius: 20px;
            padding: 0px 8px 2px;
        }
    }

    &-wrong {
        color: #ef2b2a;
        border: 1px solid #ef2b2a !important;
        border-radius: 10px;

        .item-correct_num {
            background-color: #fc6a8f;
            border-radius: 20px;
            padding: 0px 8px 2px;
        }
    }
}

.mark__list {
    font-size: 1.1vw;
    font-weight: 500;
    line-height: 1.85vw;
    word-break: keep-all;
}
</style>
